<mat-card class="live-simulator" *ngIf="simulation">
    <mat-card-header>
        <mat-card-title>
            <h2>
                2. {{'dashboard.simulator.title.shortLabel' | translate}}
                <app-tooltip text="{{'dashboard.simulator.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="gauges">
            <app-gauges-list
                class="gauges-group"
                [years]="simulation.kpisByYear"
                [selectedYear]="selectedYear.year"
                [startIndex]="0"
                [stopIndex]="getMidLength(1)"></app-gauges-list>

            <div class="gauges-group main-gauge">
                <app-gauge-double
                    [year]="selectedYear.year"
                    [isEstimated]="selectedYear.isEstimated"
                    [kpis]="filteredKpis"
                    [isAlone]="filteredKpis.length === 1"></app-gauge-double>

                <button mat-raised-button color="accent" (click)="onResetSimu()">
                    <mat-icon aria-label="Refresh">refresh</mat-icon> {{'dashboard.simulator.reset.shortLabel' | translate}}
                </button>
            </div>

            <app-gauges-list
                class="gauges-group"
                [years]="simulation.kpisByYear"
                [selectedYear]="selectedYear.year"
                [startIndex]="getMidLength()"
                [stopIndex]="simulation.kpisByYear.length - 1"></app-gauges-list>
        </section>

        <ng-container *ngIf="!isFormVisible; else formBlock">
            <section class="cursors">
                <app-cursors-list class="cursors-list"
                    [partitions]="simulation.partitions"
                    articleType="receipt"
                    (applyPercent)="changePartValue($event)"></app-cursors-list>
                <app-cursors-list class="cursors-list"
                    [partitions]="simulation.partitions"
                    articleType="expense"
                    (applyPercent)="changePartValue($event)"></app-cursors-list>
            </section>

            <section class="actions">
                <div *ngIf="simulation.useCompletionRate != null && !simulation.isMJP" class="completion-rate">
                    <mat-checkbox
                        [(ngModel)]="simulation.useCompletionRate"
                        [matTooltip]="'dashboard.useCompletionRate.summary' | translate"
                        (change)="onApplyCompletionRate()">
                        {{ 'dashboard.useCompletionRate.fullLabel' | translate }}
                    </mat-checkbox>
                </div>

                <button mat-raised-button color="accent" (click)="onToggleForm()">
                    <mat-icon aria-label="Save">save</mat-icon>
                    <!-- <span class="link-label">{{link.title | translate}}</span> -->
                    {{'dashboard.saveForm.save.fullLabel' | translate}}
                </button>
            </section>
        </ng-container>

        <ng-template #formBlock>
            <section class="save-form" *ngIf="isFormVisible">
                <app-save-simulation-form [simulation]="simulation" (hideForm)="onToggleForm()"></app-save-simulation-form>
            </section>
        </ng-template>

        <p>
            <mat-icon color="accent">arrow_drop_down</mat-icon> {{'dashboard.goToResults.fullLabel' | translate}} <mat-icon color="accent">arrow_drop_down</mat-icon>
        </p>
    </mat-card-content>
</mat-card>
